import React from 'react';
import { Typography } from '@mui/material';
import { formatOptionalDate } from '../clients/utils/format';

/** Required on cell content for DataTable row clicks (see sharedModules/dataTable/DataTable/TableRow). */
export const ROW_CLICK_TAG = '___react-data-table-allow-propagation___';

type LastContactRow = { last_contact_at?: string | null };

/** Shared by the Collections and Statements lists. Sort by instant; 0 = no notes (oldest). */
export const lastContactColumn = {
  name: 'Last Contact',
  selector: (row: LastContactRow) => (row.last_contact_at ? Date.parse(row.last_contact_at) : 0),
  sortable: true,
  width: '120px',
  cell: (row: LastContactRow) => (
    <Typography variant="body2" data-tag={ROW_CLICK_TAG}>
      {formatOptionalDate(row.last_contact_at ?? null)}
    </Typography>
  ),
};
